import React, { Fragment, useContext, useState, useEffect } from "react";
import { Grid, TextField } from "@material-ui/core";

// Contexts
import CampaignContext from "../../../../context/campaign/CampaignContext";
import ProductContext from "../../../../context/checkout/products/ProductContext";

const Offer = () => {
  const { products } = useContext(ProductContext);
  const { form_data, form_error, setFormData, setFormError, searchCheckout } =
    useContext(CampaignContext);

  const [variant_list, setVariantList] = useState([]);

  const handleChange = (e) => {
    const id = e.target.id;

    if (id === "product_id") {
      let value = parseInt(e.target.value.replace(/\s+/g, ""));
      form_data[id] = value;
      form_error[id] = "";

      searchCheckout(value);
    } else if (id === "recommended") {
      form_data.deals[id] = parseInt(e.target.value);
    } else if (id === "super_saver") {
      form_data.deals[id] = parseInt(e.target.value);
      form_error[id] = "";
    }

    setFormData(form_data);
    setFormError(form_error);
  };

  useEffect(() => {
    if (form_data.product_id) {
      for (let a in products) {
        if (products[a].id.toString() === form_data.product_id.toString()) {
          setVariantList(products[a].variants);

          if (
            form_data.deals.recommended === "" &&
            form_data.deals.super_saver === ""
          ) {
            // Set Default Deals When Product Changed
            if ("deals" in products[a]) {
              form_data.deals.recommended = products[a].deals.recommended;
              form_data.deals.super_saver = products[a].deals.super_saver;
            } else {
              form_data.deals.recommended = products[a].variants[0].id;
              form_data.deals.super_saver = "";
            }
          }

          setFormData(form_data);
          break;
        }
      }
    }
  }, [form_data.product_id]);

  return (
    <Fragment>
      {/* Main Product (Offer) */}
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          label="Offer"
          id="product_id"
          name="product_id"
          onChange={handleChange}
          value={products && form_data.product_id}
          error={form_error.product_id ? true : false}
          helperText={form_error.product_id}
        >
          <option value="" disabled />
          {products &&
            products.map((each) => {
              return (
                <option key={each.id} value={each.id}>
                  {each.title}
                </option>
              );
            })}
        </TextField>
      </Grid>
      {/* Recommended Deal */}
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          label="Recommended Deal"
          id="recommended"
          name="recommended"
          onChange={handleChange}
          value={variant_list.length > 0 && form_data.deals.recommended}
        >
          <option value="" disabled />
          {variant_list.length > 0 &&
            variant_list.map((each) => {
              return (
                <option key={each.id} value={each.id}>
                  {each.title}
                </option>
              );
            })}
        </TextField>
      </Grid>
      {/* Super Saver Deal */}
      <Grid item xs={4}>
        <TextField
          required
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          label="Super Saver Deal"
          id="super_saver"
          name="super_saver"
          onChange={handleChange}
          value={variant_list.length > 0 && form_data.deals.super_saver}
          error={form_error.super_saver ? true : false}
          helperText={form_error.super_saver}
        >
          <option value="" disabled />
          {variant_list.length > 0 &&
            variant_list.map((each) => {
              return (
                <option key={each.id} value={each.id}>
                  {each.title}
                </option>
              );
            })}
        </TextField>
      </Grid>
    </Fragment>
  );
};

export default Offer;
